/**
 * How a Webhook action node's response should be handled.
 * Mirrors Osstre.Domain WorkflowNodeActionResponseType.
 */
export enum WorkflowNodeActionResponseType {
  None = 'none',
  Object = 'object',
  String = 'string'
}
